import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import FormControl from '@material-ui/core/FormControl'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import CustomExpansionPanel from '../custom-material/expansion-panel/ExpansionPanel'
import CustomExpansionPanelDetails from '../custom-material/expansion-panel/ExpansionPanelDetails'
import CustomFormControlLabel from '../custom-material/form-control-label/FormControlLabel'
import { SmallCustomSwitch } from '../custom-material/switch/Switch'
import { TitleCustomExpansionPanelSummary } from '../custom-material/expansion-panel/ExpansionPanelSummary'
import CustomTypography from '../custom-material/typography/Typography'
import EmptyStateComponent from '../common/empty-state/EmptyStateComponent'
import { isEmpty } from 'lodash'

const styles = theme => ({
  expansionPanelTitle: {
    fontSize: 22,
    fontWeight: 'normal',
    paddingRight: 0,
    display: 'flex',
    alignItems: 'center'
  },
  formControlLabel: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 4
  },
  disabledSwitch: {
    backgroundColor: '#C0C0C0 !important'
  }
})

class ProductAlertExpansionPanel extends React.PureComponent {
  render () {
    const { classes, exclusions, toggleExclusion } = this.props

    // The contact schema function returns products in the same filter_groups array as the watch
    // list and general alert settings, tagged with section "Product". Pick out just those.
    const products =
      exclusions && Array.isArray(exclusions.filter_groups)
        ? exclusions.filter_groups.filter(group => group && group.section === 'Product')
        : []

    return (
      <CustomExpansionPanel defaultExpanded>
        <TitleCustomExpansionPanelSummary expandIcon={<ArrowRightIcon style={{fontSize: 50}} />}>
          <CustomTypography className={classes.expansionPanelTitle}>IPD Publication Settings</CustomTypography>
        </TitleCustomExpansionPanelSummary>
        <CustomExpansionPanelDetails style={{paddingTop: 16, paddingBottom: 16}}>
          <FormControl component='fieldset' className={classes.formControl}>
            {isEmpty(products)
              ? <EmptyStateComponent title='No Product Settings found' />
              : products.map((product, i) => (
                <div key={product.id || product.name || i} style={{ display: 'flex', alignItems: 'center' }}>
                  <CustomFormControlLabel
                    label={
                      <span className={classes.formControlLabel}>
                        {product.name}&nbsp;
                      </span>
                    }
                    control={
                      // filtered === false means the contact receives the product's emails, so the
                      // switch reads on. filtered === null means no access, so it is greyed out.
                      <SmallCustomSwitch
                        classes={{track: product.filtered === null ? classes.disabledSwitch : ''}}
                        disableRipple
                        checked={product.filtered === false}
                        disabled={product.filtered === null}
                        onChange={toggleExclusion(product.name)}
                      />
                    }
                  />
                </div>
              ))}
          </FormControl>
        </CustomExpansionPanelDetails>
      </CustomExpansionPanel>
    )
  }
}

ProductAlertExpansionPanel.propTypes = {
  classes: PropTypes.object.isRequired,
  exclusions: PropTypes.object,
  toggleExclusion: PropTypes.func.isRequired
}

export default withStyles(styles)(ProductAlertExpansionPanel)
